import type { Worker } from 'node:worker_threads';
import { dirname, join } from 'node:path';
import { fileURLToPath } from 'node:url';

export const WORKER_SHUTDOWN_GRACE_MS = 3_000;

let worker: Worker | null = null;
let terminatePromise: Promise<void> | null = null;

export function getWorker(): Worker | null {
  return worker;
}

export function setWorker(next: Worker | null): void {
  worker = next;
}

export function getTerminatePromise(): Promise<void> | null {
  return terminatePromise;
}

export function setTerminatePromise(next: Promise<void> | null): void {
  terminatePromise = next;
}

export function shouldUseInProcessWorker(): boolean {
  return process.env.VITEST === 'true' || process.env.BUILDAMATON_SYMBOL_INDEX_INLINE === '1';
}

export function resolveWorkerScriptPath(): string {
  const moduleDir = dirname(fileURLToPath(import.meta.url));
  return join(moduleDir, '..', 'worker.js');
}

export function resetLifecycleStateForTests(): void {
  terminatePromise = null;
  worker = null;
}
